export const AQUA_NETWORK_URL = 'https://aqua.network';

export const GALAXYRAMP_WIDGET_URL = 'https://aqua-prod--buy-any-crypto-web.netlify.app/';
